import { Box, DialogContentText } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'
import DialogConfirmation, {
  DialogConfirmationProps
} from './DialogConfirmation'

export type DialogDurationChangeProps = {
  billing?: number
  payroll?: number
} & DialogConfirmationProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    labelGrey: {
      color: theme.palette.grey[700]
    },
    priceDuration: {
      marginTop: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  })
)

const DialogDurationChange: React.FC<DialogDurationChangeProps> = (props) => {
  const classes = useStyles()
  const { billing, payroll, contentText, ...rest } = props
  return (
    <DialogConfirmation
      content={
        <Box>
          <DialogContentText variant="body2">{contentText}</DialogContentText>
          <Box>
            <Box>
              <Typography
                color="primary"
                variant="subtitle1"
                children="Billing Adjustments"
              />
              <Box className={classes.priceDuration}>
                <Typography
                  className={classes.labelGrey}
                  variant="body1"
                  children="Duration Change:"
                />
                <Typography
                  variant="subtitle1"
                  children={`$${billing ? billing : 0}`}
                />
              </Box>
            </Box>
            <Box marginTop={2}>
              <Typography
                color="primary"
                variant="subtitle1"
                children="Payroll Adjustmens"
              />
              <Box className={classes.priceDuration}>
                <Typography
                  className={classes.labelGrey}
                  variant="body1"
                  children="Duration Change:"
                />
                <Typography
                  variant="subtitle1"
                  children={`$${payroll ? payroll : 0}`}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      }
      {...rest}
    />
  )
}

export default DialogDurationChange
